import state from './state';
import getters from './getters';

export default {
  namespaced: true,
  state,
  getters,
}
